import api from './api';
import qs from 'qs';

export type ReportsReasonType = 'ABUSE' | 'SPAM' | 'NUDITY' | 'HAJEM_RULES';

export type ReportType = 'CHAT_REPORT' | 'PROFILE_REPORT';

type getAvailableReportsPropsType = {
  reacted?: boolean;
  reason?: ReportsReasonType;
  type?: ReportType,
  cursor?: string
}

export const getAvailableReports = async (props?: getAvailableReportsPropsType) => {
  const reportsList = await api.get(`reports?${qs.stringify(props)}`);
  
  return reportsList.data;
}

export const reactToReport = async (reportId: string, reaction: 'BLOCK_CHAT' | 'DECLINE_REPORT') => {
  const reportsList = await api.post(`reports/${reportId}`, { data: { reaction }});
  
  return reportsList.data;
}